import classes from "./IntroSection.module.css";
import startBtn from "../../../img/HomePageImg/startBtn.png";
import { Link } from 'react-router-dom';


function IntroSection() {
  return (
    <div className={classes.intro_section}>
      <div></div>
      <div className={classes.main_content}>
        <h1 className={classes.title}>
          הפוך את נסחי הטאבו שלך לאקסל <span>תוך שניות!</span>
        </h1>
        <div className={classes.subtitle}>
          <p>
          טאבופיי הוא השירות המוביל להמרת נסחי טאבו לקובץ
            <span> Excel </span>
            מסודר ומרוכז.
          </p>
          <p>פשוט, מהיר וללא מאמץ.</p>
        </div>
        <Link to="/upload-tabu" className={classes.button}>
          <p>המר נסח טאבו עכשיו</p>
          {/* <img src={startBtn}></img> */}
        
        </Link>
        {/* <button className={classes.button}>
          <p>המר נסח טאבו עכשיו</p>
          <img src={startBtn}></img>
        </button> */}
      </div>
      <p className={classes.bottom_line}>
        * סוגי הנסחים הנתמכים: נסח רגיל מפנקס הזכויות . ונסח מרוכז מפנקס הבתים
        המשותפים.
      </p>
    </div>
  );
}

export default IntroSection;
